import React from "react";
import { ExternalLinkBox } from "./ExternalLinkBox";

type ImageTextDisplayProps = {
  removeImage?: () => void;
  title: string;
  url: string;
};

export const ExternalImageBox: React.FC<ImageTextDisplayProps> = ({ removeImage, title, url }) => (
  <ExternalLinkBox title={title} url={url} onRemove={removeImage}>
    <div
      className="min-h-4 m-2 h-24 flex-1 basis-24 bg-contain bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${url})` }}
    />
  </ExternalLinkBox>
);
